/* BB PRODUCT — bb-product.js */
(function () {
  'use strict';

  /* ─────────────────────────────────────────
     PRODUCT DATA
  ───────────────────────────────────────── */
  var productData = null;
  var selectedOptions = [];

  function loadProductData() {
    var el = document.getElementById('bbp-product-json');
    if (!el) return;
    try {
      productData = JSON.parse(el.textContent);
      /* Seed selectedOptions from the initially selected swatch in each option group */
      var wrap = document.querySelector('.bbp');
      if (!wrap) return;
      wrap.querySelectorAll('.bbp__option').forEach(function (optEl, i) {
        var active = optEl.querySelector('.bbp__swatch.is-selected');
        selectedOptions[i] = active ? active.dataset.value : null;
      });
    } catch (e) {
      console.warn('[bbp] Could not parse product JSON', e);
    }
  }

  /* Find the variant whose options array exactly matches selectedOptions */
  function findVariant() {
    if (!productData) return null;
    return productData.variants.find(function (v) {
      return selectedOptions.every(function (val, i) {
        return v.options[i] === val;
      });
    }) || null;
  }

  /* Format price in cents to "$X.XX" */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ─────────────────────────────────────────
     UPDATE UI AFTER VARIANT CHANGE
  ───────────────────────────────────────── */
  function updateUI(variant) {
    if (!variant) return;

    var wrap = document.querySelector('.bbp');

    /* Price */
    var priceEl   = document.getElementById('bbp-price');
    var stickyPriceEl = document.getElementById('bbp-sticky-price');
    if (priceEl) priceEl.textContent = formatMoney(variant.price);
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);

    /* Compare-at price & sale badge — rebuild price-wrap */
    var priceWrap = wrap ? wrap.querySelector('.bbp__price-wrap') : null;
    if (priceWrap) {
      var compareEl = priceWrap.querySelector('.bbp__price--compare');
      var saleBadge = priceWrap.querySelector('.bbp__badge-sale');
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'bbp__price--compare';
          priceEl.insertAdjacentElement('afterend', compareEl);
        }
        compareEl.textContent = formatMoney(variant.compare_at_price);
        if (!saleBadge) {
          saleBadge = document.createElement('span');
          saleBadge.className = 'bbp__badge-sale';
          compareEl.insertAdjacentElement('afterend', saleBadge);
        }
        var saving = variant.compare_at_price - variant.price;
        saleBadge.textContent = 'Save ' + formatMoney(saving);
      } else {
        if (compareEl) compareEl.remove();
        if (saleBadge) saleBadge.remove();
      }
    }

    /* Pre-order badge */
    var isPreorder = (
      variant.inventory_management === 'shopify' &&
      variant.inventory_policy === 'continue' &&
      variant.inventory_quantity <= 0
    );
    var preorderBadge = wrap ? wrap.querySelector('[data-preorder-badge]') : null;
    if (preorderBadge) {
      preorderBadge.classList.toggle('hide', !isPreorder);
    }

    /* Inventory dot */
    var invEl = wrap ? wrap.querySelector('.bbp__inventory') : null;
    if (invEl) {
      if (isPreorder) {
        invEl.innerHTML = '<span class="bbp__dot" style="background:#9A9871;"></span> Pre-Order';
      } else if (variant.available) {
        invEl.innerHTML = '<span class="bbp__dot bbp__dot--in"></span> In Stock';
      } else {
        invEl.innerHTML = '<span class="bbp__dot bbp__dot--out"></span> Sold Out';
      }
    }

    /* ATC button */
    var atcBtn = document.getElementById('bbp-atc');
    var stickyBtn = document.getElementById('bbp-sticky-atc');
    if (atcBtn) {
      atcBtn.dataset.variantId = variant.id;
      var atcText  = atcBtn.dataset.atcText  || 'Add to Cart';
      var soldText = atcBtn.dataset.soldText || 'Sold Out';
      atcBtn.disabled = !variant.available;
      atcBtn.innerHTML =
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
        (variant.available ? (isPreorder ? 'Pre-Order' : atcText) : soldText);
    }
    if (stickyBtn) {
      stickyBtn.dataset.variantId = variant.id;
      stickyBtn.disabled = !variant.available;
      stickyBtn.textContent = atcBtn.textContent.trim();
    }

    /* Dim unavailable swatches for other option groups */
    markUnavailableSwatches();

    /* Update URL without reload */
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  }

  /* Grey out swatches that produce no available variant */
  function markUnavailableSwatches() {
    if (!productData) return;
    var wrap = document.querySelector('.bbp');
    if (!wrap) return;

    wrap.querySelectorAll('.bbp__option').forEach(function (optEl, optIdx) {
      optEl.querySelectorAll('.bbp__swatch').forEach(function (btn) {
        var testOptions = selectedOptions.slice();
        testOptions[optIdx] = btn.dataset.value;
        var available = productData.variants.some(function (v) {
          return testOptions.every(function (val, i) {
            return val === null || v.options[i] === val;
          }) && v.available;
        });
        btn.disabled = !available;
        btn.style.opacity = available ? '' : '0.35';
        btn.title = available ? '' : 'Unavailable';
      });
    });
  }

  /* ─────────────────────────────────────────
     GALLERY
  ───────────────────────────────────────── */
  function initGallery() {
    var main   = document.getElementById('bbp-main-img');
    var thumbs = document.querySelectorAll('.bbp__gallery-thumb');
    var arrows = document.querySelectorAll('.bbp__gallery-arrow');
    if (!main || !thumbs.length) return;

    var current = 0;

    function goTo(idx) {
      if (idx < 0) idx = thumbs.length - 1;
      if (idx >= thumbs.length) idx = 0;
      current = idx;
      var btn = thumbs[idx];
      main.src = btn.dataset.src;
      main.alt = btn.dataset.alt || '';
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
    }

    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { goTo(i); });
    });

    arrows.forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(btn.classList.contains('bbp__gallery-arrow--prev') ? current - 1 : current + 1);
      });
    });

    /* Touch swipe on main image */
    var startX = 0;
    main.parentElement.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });
    main.parentElement.addEventListener('touchend', function (e) {
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });
  }

  /* ─────────────────────────────────────────
     QUANTITY
  ───────────────────────────────────────── */
  function initQty() {
    var input = document.getElementById('bbp-qty');
    var minus = document.getElementById('bbp-qty-minus');
    var plus  = document.getElementById('bbp-qty-plus');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value) - 1);
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = parseInt(input.value) + 1;
    });
  }

  /* ─────────────────────────────────────────
     VARIANT SELECTION
  ───────────────────────────────────────── */
  function initVariants() {
    var wrap = document.querySelector('.bbp');
    if (!wrap || !productData) return;

    wrap.querySelectorAll('.bbp__swatch').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;

        var optIdx = parseInt(btn.dataset.optionIndex);

        /* Update selected state for this option group */
        wrap.querySelectorAll('.bbp__swatch[data-option-index="' + optIdx + '"]').forEach(function (s) {
          s.classList.remove('is-selected');
        });
        btn.classList.add('is-selected');

        /* Update the displayed label */
        var label = wrap.querySelector('#bbp-option-val-' + (optIdx + 1));
        if (label) label.textContent = btn.dataset.value;

        /* Record selection */
        selectedOptions[optIdx] = btn.dataset.value;

        /* Find matching variant and update UI */
        var variant = findVariant();
        if (variant) updateUI(variant);
      });
    });

    /* Run initial unavailable check */
    updateUI(findVariant());
    markUnavailableSwatches();
  }

  /* ─────────────────────────────────────────
     ADD TO CART
  ───────────────────────────────────────── */
  function initATC() {
    var atcBtn    = document.getElementById('bbp-atc');
    var stickyBtn = document.getElementById('bbp-sticky-atc');
    var qtyInput  = document.getElementById('bbp-qty');
    if (!atcBtn) return;

    function addToCart(variantId) {
      if (!variantId || atcBtn.disabled || atcBtn.classList.contains('is-loading')) return;
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      atcBtn.disabled = true;
      atcBtn.classList.add('is-loading');
      if (stickyBtn) { stickyBtn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart error ' + r.status);
        return r.json();
      })
      .then(function () {
        var origText = atcBtn.dataset.atcText || 'Add to Cart';
        atcBtn.innerHTML =
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"><polyline points="20 6 9 17 4 12"/></svg> Added!';
        setTimeout(function () {
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-loading');
          if (stickyBtn) { stickyBtn.disabled = false; }
          atcBtn.innerHTML =
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="square"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>' +
            origText;
        }, 1800);
        /* Trigger Shopify cart refresh for themes that listen */
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) {
        console.error('[bbp] Add to cart failed', err);
        atcBtn.disabled = false;
        atcBtn.classList.remove('is-loading');
        if (stickyBtn) { stickyBtn.disabled = false; }
      });
    }

    atcBtn.addEventListener('click', function () {
      addToCart(atcBtn.dataset.variantId);
    });

    if (stickyBtn) {
      function syncSticky() {
        stickyBtn.disabled = atcBtn.disabled || atcBtn.classList.contains('is-loading');
        stickyBtn.textContent = atcBtn.textContent.trim();
        stickyBtn.dataset.variantId = atcBtn.dataset.variantId;
      }
      new MutationObserver(syncSticky).observe(atcBtn, {
        attributes: true, attributeFilter: ['disabled', 'class', 'data-variant-id'],
        childList: true, subtree: true, characterData: true
      });
      syncSticky();
      stickyBtn.addEventListener('click', function () {
        addToCart(atcBtn.dataset.variantId);
      });
    }
  }

  /* ─────────────────────────────────────────
     ACCORDION
  ───────────────────────────────────────── */
  function initAccordion() {
    document.querySelectorAll('.bbp__accordion-header').forEach(function (hdr) {
      hdr.addEventListener('click', function () {
        var item = hdr.closest('.bbp__accordion-item');
        var open = item.classList.contains('is-open');
        /* Close all */
        document.querySelectorAll('.bbp__accordion-item.is-open').forEach(function (i) {
          i.classList.remove('is-open');
          i.querySelector('.bbp__accordion-header').setAttribute('aria-expanded', 'false');
        });
        /* Open clicked if it was closed */
        if (!open) {
          item.classList.add('is-open');
          hdr.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  /* ─────────────────────────────────────────
     STICKY ATC
  ───────────────────────────────────────── */
  function initSticky() {
    var sticky = document.getElementById('bbp-sticky');
    var atcBtn = document.getElementById('bbp-atc');
    if (!sticky || !atcBtn) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) {
          sticky.classList.add('is-visible');
          sticky.removeAttribute('aria-hidden');
        } else {
          sticky.classList.remove('is-visible');
          sticky.setAttribute('aria-hidden', 'true');
        }
      });
    }, { threshold: 0.1 });

    observer.observe(atcBtn);
  }

  /* ─────────────────────────────────────────
     INIT
  ───────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    loadProductData();
    initGallery();
    initQty();
    initVariants();
    initATC();
    initAccordion();
    initSticky();
  });

})();

